import axios from "axios";

const api = axios.create({
    // baseURL: "https://beta.bustan-messenger.ir",
    // baseURL: "https://api.bustan-messenger.ir",
    baseURL: "https://api.bustan-messenger.ir",

    headers: {
        "Content-Type": "application/json",
    },
});

// ------------------------------- login ---------------------------------------------------
// export const loginUser = async (userName, pass) => {
//     const data = JSON.stringify({
//         userName,
//         pass,
//     });

//     const response = await api.post(
//         "/login_admin",
//         data,
//         {
//             headers: {
//                 "Content-Type": "application/json",
//                 token: "",
//             },
//         }
//     );
//     return response;
// }
export const loginUser = async (userName, pass) => {
    var data = JSON.stringify({
        "userName": userName,
        "pass": pass
    });

    const response = await api.post("/login_admin", {
        headers: {
            "Content-Type": "application/json",
            token: "",
        },
        data: data
    });
    return response;
};


// ------------------------------- GetUsers ---------------------------------------------------
// export const getUsers = async (token) => {
//     const response = await api.get(
//         "/get_organization_users?range_start=1757423292699&range_end=-1&FromAbove=true",
//         {
//             headers: {
//                 'token': token,
//             },
//         }
//     );
//     console.log(response)
//     return response.data;
// };

export const getUsers = async (token) => {
    const response = await api.get(
        "/get_organization_users?range_start=1&range_end=0",
        {
            headers: {
                'token': token,
            },
        }
    );
    console.log(response)
    return response.data;
};


// ------------------------------- getUser ---------------------------------------------------
export const getUser = async (token, phone) => {
    const response = await api.get(
        `/get_organization_user?PhoneNumber=${phone}`,
        {
            headers: {
                'token': token,
            },
        }
    );
    return response.data;
};

// ------------------------------- getBrands ---------------------------------------------------
export const getBrands = async (token) => {
    const response = await api.get(
        "/get_brands",
        {
            headers: {
                token: token || "",
            },
        }
    );

    // Some APIs nest data inside a `data` field, others return the array directly.
    return response.data?.data ?? response.data;
};

// ------------------------------- createBrand ---------------------------------------------------
export const createBrand = async (token, brandPayload) => {
    const response = await api.post(
        "/add_brand",
        JSON.stringify(brandPayload),
        {
            headers: {
                token: token || "",
                "Content-Type": "application/json",
            },
        }
    );
    return response;
};

// ------------------------------- updateBrand ---------------------------------------------------
export const updateBrand = async (token, payload) => {
    const response = await api.put(
        "/edit_brand",
        payload,
        {
            headers: {
                token: token || "",
                "Content-Type": "application/json",
            },
        }
    );

    return response;
};

// ------------------------------- AddOrganizationUser ---------------------------------------------------
export const AddOrganizationUser = async (token, name, phone, bio, urlWebHook, tokenWebHook, ip) => {
    var data = JSON.stringify({
        "webHookCallbackUrl": urlWebHook,
        "webHookToken": tokenWebHook,
        "name": name,
        "phoneNumber": phone,
        "profileText": bio,
        "ip": ip
    });
    const response = await api.post(
        "/set_organization_user",
        data,
        {
            headers: {
                "Token": token,
                "Access-Control-Allow-Origin": "*",
                "Content-Type": "application/json"
            }
        }
    );
    return response;
};


// -------------------------------edit_organization_user ---------------------------------------------------
export const editOrganizationUser = async (token, id, name, phone, bio, urlWebHook, tokenWebHook, ip) => {
    var data = JSON.stringify({
        "id": id,
        "webHookCallbackUrl": urlWebHook,
        "webHookToken": tokenWebHook,
        "name": name,
        "phoneNumber": phone,
        "profileText": bio,
        "ip": ip
    });
    const response = await api.put(
        "/edit_organization_user",
        data,
        {
            headers: {
                "Token": token,
                "Access-Control-Allow-Origin": "*",
                "Content-Type": "application/json"
            }
        }
    );
    return response;
};


// ------------------------------- delete_organization_user ---------------------------------------------------
export const deleteOrganizationUser = async ({ token, id }) => {

    const response = await api.delete(
        `/delete_organization_user?id=${id}`,
        {
            headers: {
                "Token": token,
                "Access-Control-Allow-Origin": "*",
                "Content-Type": "application/json"
            }
        }
    );
    return response;
}


// ------------------------------- upload_organization_avatar ---------------------------------------------------
export const uploadOrganizationAvatar = async (token, file, id, webHookCallbackUrl) => {
    const arrayBuffer = await file.arrayBuffer();

    const response = await api.post(
        `/update_organization_profile?id=${id}&webHookCallbackUrl=${webHookCallbackUrl}`,
        arrayBuffer,
        {
            headers: {
                "token": token,
                "Content-Type": "application/octet-stream"
            }
        }
    );

    return response.data;
};


// ------------------------------- get_image_file_info ---------------------------------------------------
export const getImageFileInfo = async (token, id) => {
    const response = await api.get(
        `/get_image_file_info?id=${id}`,
        {
            headers: {
                token: token,
            },
        }
    );
    return response.data;
};


// ------------------------------- download image ---------------------------------------------------
export const downloadImage = async (token, id, fileSize) => {
    const response = await api.get(
        `/download?range_end=${fileSize}&range_start=0&type=IMAGE&id=${id}`,
        {
            headers: {
                token: token,
            },
            responseType: "blob",
        }
    );
    return response.data;
};

// ------------------------------- download_brand_certificates ---------------------------------------------------
export const downloadBrandCertificates = async (token, id) => {
    const response = await api.get(
        `/get_certs_brand?id=${id}`,
        {
            headers: {
                token: token || "",
            },
            responseType: "blob",
        }
    );
    return response.data;
};

// ------------------------------- ---------------------------------------------------
// ------------------------------- delete_brand ---------------------------------------------------
export const deleteBrand = async (token, id) => {
    const response = await api.delete(
        `/delete_brand?id=${id}`,
        {
            headers: {
                token: token,
                "Content-Type": "application/json",
            },
        }
    );
    return response;
};

// ------------------------------- update_token_brand ---------------------------------------------------
export const updateTokenBrand = async (token, id) => {
    const response = await api.get(
        `/update_token_brand?id=${id}`,
        {
            headers: {
                token: token,
                "Content-Type": "application/json",
            },
        }
    );
    return response;
};

// ------------------------------- update_certificate_brand ---------------------------------------------------
export const updateCertificateBrand = async (token, id) => {
    const response = await api.get(
        `/update_certificate_brand?id=${id}`,
        {
            headers: {
                token: token,
                "Content-Type": "application/json",
            },
        }
    );
    return response;
};

export default api;
